import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useDateRangePicker from '../../../components/organisms/forms/date-range-picker/reusable-func';

function useRoutes() {
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Params from url
  * Url format : /routes/:currentScreen
  */
  const { currentScreen } = useParams();

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Switch current screen is route or schedule by Stepper Component
  */
  const [searchParams] = useSearchParams();
  const [step, setStep] = React.useState<number>(0);
  // This needed to set initial step after update or add schedule or route
  React.useEffect(() => {
    if (currentScreen === 'schedule' || !(!searchParams.get('start') || !searchParams.get('end'))) setStep(1);
    else setStep(0);
  }, [currentScreen]);

  /*
   *
   *
   *
   *
   *
   *
   *
   */

  /*
  * Navigate handler
  */
  const navigate = useNavigate();
  // Navigate to Add Route
  const onNavigateAddRoute = () => {
    navigate('/routes/route/add');
  };
  // Navigate to Add Schedule
  const onNavigateAddSchedule = () => {
    navigate('/routes/schedule/add');
  };

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Date Range Picker Handler
  */
  const { handleChangeStartDate, handleChangeEndDate, selectedDate } = useDateRangePicker();

  return {
    step,
    setStep,
    onNavigateAddRoute,
    onNavigateAddSchedule,
    handleChangeStartDate,
    handleChangeEndDate,
    selectedDate,
  };
}

export default useRoutes;
